import { Text } from "@fluentui/react-components";
import { AppModal } from "@shared/modal/Modal";
import * as React from "react";
import type { PriorArt } from "./useOfficeAction";

type Props = {
  priorArt: PriorArt[];
  onClose: () => void;
};

export const FailedPriorArtAlert: React.FC<Props> = ({ priorArt, onClose }) => {
  if (!priorArt.length) return null;

  return (
    <AppModal
      open={true}
      title="Some prior art could not be uploaded"
      content={
        <>
          <Text block>
            The following prior art references could not be uploaded automatically. Please upload them manually from the
            Documents tab.
          </Text>
          <ul>
            {priorArt.map((p) => (
              <li key={`${p.country}-${p.type}-${p.id}`}>
                <Text>
                  {p.name} ({p.country} {p.id})
                </Text>
              </li>
            ))}
          </ul>
        </>
      }
      onConfirm={onClose}
      confirmText="OK"
      hideCancel
      modalType="alert"
    />
  );
};
